import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  open: false,
  onClose : '',
  type: 'success',
  modalConfig : {}
};

const modalWebisteSlice = createSlice({
  name: 'snackBar',
  initialState,
  reducers: {
    showWebsiteModal: (state, action) => {
      state.open = true;
      state.modalConfig = action.payload.modalConfig;
      state.type = action.payload.type || 'success'; // Default to success if severity not provided
    },
    onCloseWebsiteModal: (state) => {
      state.open = false;
    },
  },
});

export const { showWebsiteModal, onCloseWebsiteModal } = modalWebisteSlice.actions;

export default modalWebisteSlice.reducer;
